import { DestinationPrefix } from './DestinationPrefix'
import { FreewallFilenamePrefix } from './FreewallFilenamePrefix'

export const filenamePrefixByDestinationPrefix: Record<DestinationPrefix, FreewallFilenamePrefix> = {
  [DestinationPrefix.Ads]: FreewallFilenamePrefix.Ad,
  [DestinationPrefix.Pub]: FreewallFilenamePrefix.Pb
}
